export var UsageUnit;
(function (UsageUnit) {
    UsageUnit["USAGE_UNIT_BYTE_MONTHS"] = "BYTE_MONTHS";
    UsageUnit["USAGE_UNIT_BYTES"] = "BYTES";
    UsageUnit["USAGE_UNIT_UNSPECIFIED"] = "UNSPECIFIED";
    UsageUnit["USAGE_UNIT_OPERATIONS"] = "OPERATIONS";
    UsageUnit["USAGE_UNIT_OBJECT_MONTHS"] = "OBJECT_MONTHS";
    UsageUnit["USAGE_UNIT_SEATS"] = "SEATS";
    UsageUnit["USAGE_UNIT_OBJECTS"] = "OBJECTS";
})(UsageUnit || (UsageUnit = {}));
